// extracted by mini-css-extract-plugin
module.exports = {"MainContainer":"HomePage_MainContainer__34JeG","SectionContainer":"HomePage_SectionContainer__I8Mkb"};